<footer class="bg-app-primary-10 text-white pt-18 pb-2 px-6">
    <div class="max-w-[1200px] mx-auto">

        <div class="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 mb-16">

            <!-- Column 1 -->
            <div>
                <div class="footer-header mb-6">Kontakt</div>
                <ul class="space-y-4 text-[15px] font-light text-gray-200">
                    <li class="flex items-center gap-3">
                        <app-icon name="phone" class="w-[18px] h-[18px] text-app-secondary-10"></app-icon>
                        09162 7103
                    </li>
                    <li class="flex items-center gap-3">
                        <app-icon name="mail" class="w-[18px] h-[18px] text-app-secondary-10"></app-icon>
                        <a href="mailto:info@patriacura.de" class="hover:text-white transition-colors">info&#64;patriacura.de</a>
                    </li>
                </ul>
            </div>

            <!-- Column 2 -->
            <div>
                <div class="footer-header mb-6">Rechtliches</div>
                <ul class="space-y-4 text-[15px] font-light text-gray-200">
                    <li><a [routerLink]="'/impressum'" class="hover:text-white transition-colors cursor-pointer">Impressum</a></li>
                    <li><a [routerLink]="'/agb'" class="hover:text-white transition-colors cursor-pointer">AGB</a></li>
                    <li><a [routerLink]="'/datenschutz'" class="hover:text-white transition-colors cursor-pointer">Datenschutzerklärung</a></li>
                </ul>
            </div>

            <!-- Column 3 -->
            <div>
                <div class="footer-header mb-6">Informationen</div>
                <ul class="space-y-4 text-[15px] font-light text-gray-200">
                    <li><a [routerLink]="'/faq'" class="hover:text-white transition-colors cursor-pointer">Häufige Fragen</a></li>
                    <li><a [routerLink]="'/ueber-uns'" class="hover:text-white transition-colors cursor-pointer">Über uns</a></li>
                </ul>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            © 2026 Patria Cura. Alle Rechte vorbehalten
        </div>

    </div>
</footer>


<!--<footer class="h-8 flex items-center justify-center gap-8 pt-8">-->
<!--    <a [routerLink]="'/impressum'">Impressum</a>-->
<!--    <a [routerLink]="'/agb'">AGB</a>-->
<!--    <a [routerLink]="'/datenschutz'">Datenschutz</a>-->
<!--    <a [routerLink]="'/kontakt'">Kontakt</a>-->
<!--</footer>-->
